function initUncutHeroBanner(root) {
  if (!root || root.dataset.uncutInit === 'true') return;
  root.dataset.uncutInit = 'true';

  /* --- Barre d'annonce : rotation des messages --- */
  var announceEl = root.querySelector('.uncut-hero-banner__announce-text');
  if (announceEl) {
    var messages = [announceEl.dataset.msg1, announceEl.dataset.msg2].filter(function (msg) {
      return msg && msg.length > 0;
    });
    var rotateMs = parseInt(announceEl.dataset.rotateMs, 10) || 4500;
    if (messages.length > 1) {
      var i = 0;
      root._uncutAnnounceInterval = setInterval(function () {
        i = (i + 1) % messages.length;
        announceEl.textContent = messages[i];
      }, rotateMs);
    }
  }

  /* --- Header transparent : bascule la couleur du texte selon le fond derrière --- */
  var header = root.querySelector('.uncut-hero-banner__header');
  if (header) {
    var sampleLight = function () {
      try {
        var yb = header.getBoundingClientRect().bottom;
        var x = Math.round(window.innerWidth / 2);
        var prev = header.style.pointerEvents;
        header.style.pointerEvents = 'none';
        var el = document.elementFromPoint(x, Math.round(yb + 6));
        header.style.pointerEvents = prev || '';
        var bg = null;
        while (el) {
          var c = getComputedStyle(el).backgroundColor;
          if (c && !/rgba?\(0, ?0, ?0, ?0\)|transparent/.test(c)) {
            bg = c;
            break;
          }
          el = el.parentElement;
        }
        if (!bg) return false;
        var m = bg.match(/[\d.]+/g);
        if (!m) return false;
        var lum = (0.299 * +m[0] + 0.587 * +m[1] + 0.114 * +m[2]) / 255;
        return lum > 0.6;
      } catch (e) {
        return false;
      }
    };
    var update = function () {
      header.classList.toggle('is-on-light', sampleLight());
      root.classList.toggle('is-scrolled', window.scrollY > 0);
    };
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
    requestAnimationFrame(update);
  }

  /* --- Menu mobile --- */
  var overlay = root.querySelector('.uncut-hero-banner__mobile-overlay');
  var backdrop = root.querySelector('.uncut-hero-banner__mobile-backdrop');
  var burger = root.querySelector('.uncut-hero-banner__burger');
  var closeBtn = root.querySelector('.uncut-hero-banner__mobile-close');
  var openMobileMenu = function () {
    overlay.classList.add('is-open');
    if (backdrop) backdrop.classList.add('is-open');
  };
  var closeMobileMenu = function () {
    overlay.classList.remove('is-open');
    if (backdrop) backdrop.classList.remove('is-open');
  };
  if (overlay && burger) {
    burger.addEventListener('click', openMobileMenu);
  }
  if (overlay && closeBtn) {
    closeBtn.addEventListener('click', closeMobileMenu);
  }
  if (overlay && backdrop) {
    backdrop.addEventListener('click', closeMobileMenu);
  }
}

function destroyUncutHeroBanner(root) {
  if (!root) return;
  if (root._uncutAnnounceInterval) {
    clearInterval(root._uncutAnnounceInterval);
    root._uncutAnnounceInterval = null;
  }
  root.dataset.uncutInit = 'false';
}

function initAllUncutHeroBanners() {
  document.querySelectorAll('.uncut-hero-banner').forEach(initUncutHeroBanner);
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initAllUncutHeroBanners);
} else {
  initAllUncutHeroBanners();
}

document.addEventListener('shopify:section:load', function (event) {
  var root = event.target.querySelector('.uncut-hero-banner');
  if (root) initUncutHeroBanner(root);
});

document.addEventListener('shopify:section:unload', function (event) {
  var root = event.target.querySelector('.uncut-hero-banner');
  if (root) destroyUncutHeroBanner(root);
});
